<template>
  <div>
    <el-form-item label="Type de graphique" >
      <el-select
        v-model="graph"
        placeholder="Type de graphique"
        value-key="id"
        @change="handleChange" >
        <el-option v-for="g in graphs" :key="g.id" :label="g.label" :value="g.id" />
      </el-select>
    </el-form-item>
    <el-form-item label="Nombre de colonnes" >
      <el-input-number
        v-model="columns"
        :min="0"
        :max="20"
        @change="handleChange" />
    </el-form-item>
    <el-form-item label="Hauteur des sous-graphes" >
      <el-input-number
        v-model="subGraphHeight"
        :min="0"
        :step="50"
        @change="handleChange" />
    </el-form-item>
    <el-form-item label="Marge des sous-graphes" >
      <el-input-number
        v-model="subGraphMargin"
        :min="10"
        :step="5"
        @change="handleChange" />
    </el-form-item>
  </div>
</template>

<script>
import {Registry as graphs} from '../graph'

export default {
  props: {
    value: {
      type: String,
    }
  },
  data () {
    return {
      graph: null,
      columns: 2,
      subGraphHeight: null,
      subGraphMargin: 10
    }
  },
  computed: {
    graphs () {
      return graphs.asArray().filter(g => g.id !== 'multiple-graph')
    }
  },
  watch: {
    value: {
      handler (value) {
        if (value) {
          const data = JSON.parse(value)
          this.graph = data.graph
          this.columns = data.columns || 2
          this.subGraphHeight = data.subGraphHeight || null
          this.subGraphMargin = data.subGraphMargin || 10
        } else {
          this.graph = null
          this.columns = 2
          this.subGraphHeight = null
          this.subGraphMargin = 10
        }
      },
      immediate: true
    }
  },
  methods: {
    setDefaultValues () {
      this.graph = null
      this.columns = 2
      this.subGraphHeight = null
      this.subGraphMargin = 10
    },
    handleChange () {
      const data = {
        graph: this.graph,
        columns: this.columns,
        subGraphHeight: this.subGraphHeight,
        subGraphMargin: this.subGraphMargin
      }
      this.$emit('input', JSON.stringify(data))
      this.$emit('change', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/config/DimensionMultipleGraph.vue